import { Card } from "@shared/components/ui/card";
import { Button } from "@shared/components/ui/button";
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';

export default function WelcomeScreen({ firstName, onContinue }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-slate-50 to-slate-100"
    >
      <Card className="w-full max-w-lg p-8 border-0 shadow-2xl text-center">
        {/* Success Icon */}
        <div className="w-24 h-24 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg shadow-emerald-500/30">
          <CheckCircle2 className="w-12 h-12 text-white" />
        </div>

        {/* Welcome Message */}
        <h1 className="text-3xl font-bold text-slate-900 mb-4">
          مرحباً {firstName}
        </h1>
        <p className="text-slate-500 mb-8 text-lg">
          تم التحقق من هويتك بنجاح
        </p>

        {/* Continue Button */}
        <Button
          onClick={onContinue}
          className="w-full h-14 bg-emerald-600 hover:bg-emerald-700 text-lg font-medium"
        >
          متابعة
        </Button>
      </Card>
    </motion.div>
  );
}
